function Footer() {
  const footerYear = new Date().getFullYear()

  return (
    <footer className='footer p-2 bg-black bg-opacity-60 text-primary-content footer-center'>
      <div>
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        className='inline-block fill-current'
width="50" height="50" viewBox="0 0 500.000000 500.000000"
preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
fill="#ffff" stroke="none">
<path d="M2255 4240 c-14 -22 -25 -42 -25 -44 0 -3 -13 -25 -30 -49 -16 -25
-30 -48 -30 -53 0 -4 -10 -21 -23 -38 -13 -17 -36 -57 -52 -89 -16 -31 -34
-62 -42 -68 -7 -7 -13 -15 -13 -20 0 -7 -58 -110 -90 -159 -6 -8 -13 -22 -17
-30 -4 -8 -24 -43 -45 -78 -21 -34 -38 -65 -38 -67 0 -3 -11 -22 -23 -43 -13
-20 -39 -64 -57 -97 -18 -33 -42 -73 -52 -90 -10 -16 -21 -37 -25 -45 -4 -8
-24 -43 -45 -78 -21 -34 -38 -65 -38 -67 0 -3 -18 -34 -40 -69 -22 -35 -40
-68 -40 -75 0 -6 -4 -11 -9 -11 -5 0 -13 -10 -17 -22 -4 -13 -21 -46 -38 -74
-17 -27 -36 -59 -43 -70 -6 -10 -27 -47 -45 -82 -18 -35 -39 -68 -45 -74 -7
-6 -13 -16 -13 -23 0 -7 -7 -18 -15 -25 -8 -7 -15 -19 -15 -28 0 -8 -6 -23
-14 -31 -14 -16 -31 -45 -86 -146 -15 -27 -45 -79 -67 -115 -21 -36 -57 -96
-78 -135 -22 -38 -44 -78 -50 -87 -5 -9 -21 -36 -34 -60 -13 -24 -30 -54 -38
-68 -8 -14 -23 -38 -33 -55 -11 -16 -29 -48 -40 -70 -11 -22 -25 -47 -30 -55
-27 -43 -90 -151 -90 -155 0 -3 -18 -34 -40 -70 -22 -36 -40 -67 -40 -70 0 -4
-57 -102 -90 -155 -5 -8 -19 -34 -31 -57 -13 -24 -26 -43 -31 -43 -4 0 -8 -8
-8 -19 0 -10 -7 -24 -15 -31 -8 -7 -15 -17 -15 -22 0 -5 -16 -34 -36 -65 -19
-31 -40 -65 -45 -77 -11 -22 -14 -28 -71 -122 -21 -34 -38 -66 -38 -72 0 -6
-3 -12 -7 -14 -13 -5 -43 -65 -36 -72 3 -3 308 -6 677 -6 660 0 672 0 689 20
9 11 17 27 17 35 0 9 7 18 15 21 8 4 15 14 15 24 0 10 7 23 15 30 8 7 15 17
15 23 0 5 11 25 25 43 14 18 25 40 25 48 0 9 4 16 9 16 5 0 13 10 16 21 4 12
25 49 46 83 21 33 39 67 39 74 0 6 5 12 10 12 6 0 10 5 10 11 0 7 17 39 38 73
21 34 42 68 45 76 4 8 21 38 37 65 17 28 35 59 40 70 6 11 24 43 40 70 17 28
35 59 40 70 6 11 19 34 29 50 11 17 30 48 42 70 38 69 54 96 64 113 6 9 28 49
50 87 21 39 41 72 44 75 3 3 22 35 41 73 19 37 37 67 41 67 4 0 10 11 13 25 4
14 11 25 16 25 6 0 10 8 10 19 0 10 7 24 15 31 8 7 15 17 15 23 0 5 11 25 25
43 14 18 25 37 25 42 0 5 7 15 15 22 8 7 15 19 15 27 0 8 10 29 23 46 29 42
42 63 69 117 13 25 44 80 71 122 26 43 47 80 47 83 0 2 17 33 38 67 21 35 41
70 45 78 4 8 21 38 37 65 17 28 33 57 37 65 12 29 45 59 59 53 8 -3 26 -28 40
-57 14 -28 31 -60 38 -71 6 -11 32 -56 56 -100 25 -44 50 -87 55 -97 6 -9 30
-52 55 -95 24 -43 49 -86 55 -95 45 -74 75 -129 75 -138 0 -5 4 -10 9 -10 5 0
13 -10 17 -22 3 -12 22 -45 41 -75 18 -29 37 -61 40 -71 4 -9 11 -21 15 -27
19 -23 148 -246 148 -255 0 -5 5 -10 10 -10 6 0 10 -6 10 -14 0 -8 17 -41 38
-73 21 -32 42 -65 45 -73 4 -8 21 -37 37 -65 17 -27 35 -59 40 -70 6 -11 19
-33 30 -50 10 -16 26 -44 35 -62 9 -18 23 -37 31 -44 8 -6 14 -20 14 -29 0
-10 4 -20 8 -22 7 -3 61 -87 75 -118 4 -8 18 -33 32 -55 14 -22 31 -51 38 -65
6 -14 17 -31 24 -38 7 -7 13 -20 13 -28 0 -8 5 -14 11 -14 6 0 9 -12 7 -28
l-3 -27 -217 -3 c-205 -2 -219 -1 -235 17 -31 33 -43 50 -43 57 0 3 -17 34
-37 68 -56 90 -61 99 -72 121 -6 11 -24 43 -41 70 -16 28 -34 59 -40 70 -6 11
-22 38 -35 60 -14 22 -32 54 -40 70 -9 17 -21 39 -28 50 -56 89 -87 144 -87
154 0 6 -4 11 -9 11 -5 0 -13 10 -17 22 -3 12 -22 45 -40 74 -19 29 -34 57
-34 63 0 5 -6 16 -13 23 -10 11 -77 124 -121 203 -16 29 -38 55 -46 55 -4 0
-10 -8 -14 -17 -3 -10 -14 -31 -24 -48 -10 -16 -34 -57 -52 -90 -18 -33 -43
-76 -55 -95 -12 -19 -32 -54 -44 -78 -20 -38 -20 -46 -8 -70 12 -24 98 -174
155 -272 12 -19 31 -54 43 -77 13 -24 26 -43 31 -43 4 0 8 -7 8 -15 0 -9 9
-29 20 -45 11 -17 29 -43 40 -60 11 -16 20 -36 20 -44 0 -8 6 -19 13 -23 12
-8 17 -16 58 -91 11 -20 29 -50 39 -67 10 -16 25 -41 33 -55 53 -97 84 -152
113 -198 19 -29 34 -55 34 -58 0 -3 15 -30 32 -60 l33 -54 677 0 c373 0 678 4
678 8 0 10 -23 54 -50 97 -11 17 -24 39 -30 50 -5 11 -23 43 -40 70 -16 28
-33 57 -37 65 -4 8 -23 42 -43 75 -20 33 -40 67 -44 75 -7 16 -12 24 -68 116
-21 34 -38 67 -38 73 0 6 -4 11 -10 11 -5 0 -10 4 -10 10 0 8 -55 106 -90 160
-6 8 -14 24 -20 35 -5 11 -23 43 -40 70 -16 28 -34 59 -40 70 -5 11 -23 43
-40 70 -16 28 -34 59 -40 70 -6 11 -22 38 -35 60 -14 22 -31 51 -38 65 -6 14
-17 31 -24 38 -7 7 -13 19 -13 27 0 7 -3 15 -7 17 -10 4 -51 74 -64 111 -6 15
-15 27 -20 27 -5 0 -9 6 -9 14 0 8 -6 21 -12 28 -13 14 -23 29 -59 96 -11 20
-34 60 -50 87 -16 28 -34 59 -39 70 -6 11 -19 34 -30 50 -11 17 -24 39 -30 50
-5 11 -23 43 -40 70 -16 28 -33 57 -37 65 -3 8 -23 42 -42 75 -20 33 -42 69
-48 80 -6 11 -33 56 -59 100 -26 44 -58 100 -72 125 -14 25 -34 59 -44 75 -10
17 -21 37 -25 45 -7 15 -75 132 -93 160 -6 8 -14 24 -20 35 -5 11 -23 43 -40
70 -16 28 -33 57 -37 65 -4 8 -24 43 -45 78 -21 34 -38 66 -38 71 0 5 -3 11
-7 13 -5 2 -17 21 -28 42 -11 22 -34 59 -51 84 l-32 44 -36 -60 c-20 -33 -36
-65 -36 -71 0 -6 -4 -11 -8 -11 -4 0 -13 -12 -19 -27 -7 -16 -23 -46 -37 -68
-14 -22 -29 -47 -33 -55 -5 -13 -32 -60 -114 -198 -9 -15 -31 -54 -49 -87 -18
-33 -38 -67 -44 -75 -6 -8 -16 -24 -22 -35 -42 -77 -80 -145 -98 -175 -12 -19
-30 -52 -41 -72 -11 -21 -23 -38 -27 -38 -5 0 -8 -5 -8 -11 0 -6 -17 -39 -37
-73 -57 -92 -56 -91 -112 -191 -12 -22 -31 -53 -42 -70 -10 -16 -23 -39 -29
-50 -5 -11 -23 -42 -40 -70 -16 -27 -34 -59 -40 -70 -5 -11 -23 -42 -40 -70
-16 -27 -33 -57 -37 -65 -4 -8 -31 -54 -60 -101 -29 -47 -53 -91 -53 -97 0 -7
-4 -12 -9 -12 -5 0 -11 -8 -14 -17 -3 -10 -19 -40 -36 -68 -16 -27 -40 -68
-52 -90 -12 -22 -28 -51 -36 -65 -8 -14 -23 -38 -33 -55 -11 -16 -24 -39 -30
-50 -5 -11 -23 -42 -39 -70 -16 -27 -36 -61 -44 -75 -47 -87 -83 -150 -104
-182 -12 -21 -23 -40 -23 -43 0 -2 -17 -33 -38 -67 -21 -35 -42 -70 -46 -78
-17 -37 -35 -63 -48 -71 -7 -5 -111 -9 -231 -9 -192 0 -218 2 -224 16 -3 9 -1
24 5 33 7 9 16 25 22 36 5 11 23 43 40 70 16 28 33 57 37 65 3 8 16 31 28 50
12 19 37 62 55 95 18 33 41 74 52 90 10 17 22 39 28 50 5 11 23 43 40 70 16
28 33 57 37 65 7 15 75 132 93 160 6 8 14 24 19 35 5 11 25 44 45 74 20 29 36
57 36 62 0 5 11 26 24 47 12 20 38 65 56 100 17 34 36 62 41 62 5 0 9 7 9 15
0 9 10 30 22 48 52 76 58 87 58 101 0 8 3 16 8 18 9 4 102 164 102 177 0 5 3
11 8 13 7 3 83 131 164 278 11 19 28 49 39 65 10 17 23 39 29 50 5 11 23 43
40 70 16 28 34 59 40 70 5 11 23 43 40 70 16 28 33 57 37 65 3 8 24 42 45 76
21 34 38 64 38 68 0 3 22 41 48 84 27 42 52 84 55 92 4 8 21 38 37 65 17 28
35 59 40 70 6 11 19 34 30 50 11 17 24 39 30 50 5 11 23 43 40 70 16 28 33 57
37 65 3 8 22 39 40 69 19 30 39 63 44 75 5 12 15 30 21 41 42 65 58 97 53 105
-4 6 -92 10 -215 10 l-210 0 -25 -40z"/>
</g>
</svg>

        <p>Copyright &copy;  {footerYear} A.Alaeddine </p>
      </div>
    </footer>
  )
}

export default Footer